export const ACCORDION_TOGGLE_TRANSITION_DURATION_MS = 150;
